import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { PlanProtectionService } from '../../service/plan-protection/plan-protection.service';
import { SpinnerService } from '../../service/spinner-service/spinner.service';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from '../../dialogs/success-dialog/success-dialog.component';
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { VisualizadorPdfComponentDialog } from '../../dialogs/visualizador-pdf-dialog/visualizador-pdf-dialog.component';
import { WebcamDialogComponent } from '../../dialogs/webcam-dialog/webcam-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SeleccionarCargaModalComponent } from '../../../app/dialogs/seleccionar-carga/seleccionar-carga-dialog.component';


@Component({
  selector: 'app-plan-protection-completar',
  templateUrl: './plan-protection-completar.component.html',
  styleUrl: './plan-protection-completar.component.scss'
})
export class PlanProtectionCompletarComponent {

  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInput2') fileInput2!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInput3') fileInput3!: ElementRef<HTMLInputElement>;
  cambiarSinGuardar = false
  step = 1
  validEmail = false
  planProtectionDetail: any
  planProtectionForm: FormGroup
  model
  editMode = true
  errorValidarCorreo = false
  headerTitle = 'Datos de Proveedor'
  gallery = {
    group1: true,
    group2: false,
    group3: false,
    group4: false
  };
  planProtection: any
  years = []
  modelos = []
  yearDisabled = true
  modelDisabled = true
  marcas = []
  auto = {
    marca: 'Selecciona una marca',
    marca_slug: '',
    logo: '',
    year: '',
    modelo: ''
  }
  base64ine: any
  base64tacometro: any
  base64Placas: any
  base64NoSerie: any
  base64Firma
  tieneFirma = false
  errorsModel = {
    folio: false,
    empresa: false,
    sucursal: false,
    ordenVenta: false,
    fechaContratado: false,
    fechaVigencia: false,
    nombreCliente: false,
    apellidosCliente: false,
    correoCliente: false,
    celularCliente: false,
    marca: false,
    modelo: false,
    ano: false,
    kilometraje: false,
    img_kilometraje: false,
    placas: false,
    img_placas: false,
    noSerie: false,
    img_noSerie: false,
    sku: false,
    descripcion: false,

  }
  folio
  opcSeleccionarArchivo = 0
  subirArchivosCarrete = false

  constructor( 
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private routing: ActivatedRoute,
    private router: Router,
    private ppService: PlanProtectionService,
    private spinnerService: SpinnerService,) {
      this.folio = routing.snapshot.params["foliopp"];
      this.getDetallePP()
      this.planProtectionForm = this.fb.group({
        folio: [{value: '', disabled: true}, [Validators.required]],
        empresa: [{value: '', disabled: true}, [Validators.required]],
        sucursal: [{value: '', disabled: true}, Validators.required],
        ordenVenta: [{value: '', disabled: true}, [Validators.required]],
        fechaContratado: [{value: '', disabled: true}, [Validators.required]],
        fechaVigencia: [{value: '', disabled: true}, [Validators.required]],
        nombreCliente: [{value: '', disabled: true}, [Validators.required]],
        apellidosCliente: [{value: '', disabled: true}, [Validators.required]],
        correoCliente: [{value: '', disabled: false}, [Validators.required]],
        celularCliente: [{value: '', disabled: true}, [Validators.required]],
        marca: [{value: '', disabled: true}, [Validators.required]],
        modelo: [{value: '', disabled: true}, [Validators.required]],
        ano: [{value: '', disabled: true}, [Validators.required]],
        kilometraje: [{value: '0', disabled: false}, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        placas: [{value: '', disabled: false}, [Validators.required]],
        noSerie: [{value: '', disabled: false}, [Validators.required]],
        sku: [{value: '', disabled: true}, [Validators.required]],
        descripcion: [{value: '', disabled: true}, [Validators.required]],
        filtro: new FormControl('')
      })
  }

  canExit(): boolean {
    // lógica para determinar si se puede salir
    // console.log(this.cambiarSinGuardar)
    return this.cambiarSinGuardar;
  }

  ngOnInit() {
    this.getMarcas()
  }

  getDetallePP(){
    this.ppService.getDetallesPlanProtection({empresaId: 0, folio: this.folio}).subscribe(
      data => {
        if(data.filespaths.length > 0){
          this.showError('El Plan protection ' + this.folio + ' ya se generó anteriormente.')
          this.cambiarSinGuardar = true
          this.closeDialog()
        }
        this.planProtectionDetail = data
        this.planProtection = data
        this.planProtectionForm = this.fb.group({
          folio: [{value: data.folio, disabled: true}, [Validators.required]],
          empresa: [{value: data.empresaId, disabled: true}, [Validators.required]],
          sucursal: [{value: data.nombreSucursal, disabled: true}, Validators.required],
          ordenVenta: [{value: data.ordenVentaId, disabled: true}, [Validators.required]],
          fechaContratado: [{value: data.fechaVenta, disabled: true}, [Validators.required]],
          fechaVigencia: [{value: data.fechaVigencia, disabled: true}, [Validators.required]],
          nombreCliente: [{value: data.nombreCliente, disabled: true}, [Validators.required]],
          apellidosCliente: [{value: data.apellidos, disabled: true}, [Validators.required]],
          noCliente: [{value: data.clienteId, disabled: true}, [Validators.required]],
          correoCliente: [{value: data.email, disabled: false}, [Validators.required]],
          celularCliente: [{value: data.celular, disabled: true}, [Validators.required]],
          marca: [{value: '', disabled: true}, [Validators.required]],
          modelo: [{value: '', disabled: true}, [Validators.required]],
          ano: [{value: '', disabled: true}, [Validators.required]],
          kilometraje: [{value: '0', disabled: false}, [Validators.required,]],
          placas: [{value: '', disabled: false}, [Validators.required]],
          noSerie: [{value: '', disabled: false}, [Validators.required]],
          sku: [{value: data.sku, disabled: true}, [Validators.required]],
          descripcion: [{value: data.descripcion, disabled: true}, [Validators.required]],
          filtro: new FormControl('')
        })
        
        if(data.fechaVenta === '05/12/25' || data.fechaVenta === '06/12/25'){
          this.subirArchivosCarrete = true
        }else {
          this.subirArchivosCarrete = false
        }
        this.validarEmail(this.planProtectionForm.value.correoCliente)
      }
    )
  }

  getMarcas(){
    this.ppService.getMarcas().subscribe(
      data => {
        this.marcas = data.data
      }
    )
  }   

  validateStep(opc){
    if(opc === 1){
      if(this.step === 1){
        if(this.planProtectionForm.value.sucursal !== '' && this.planProtectionForm.value.ordenVenta !== '' && this.planProtectionForm.value.sku !== '' && 
          this.planProtectionForm.value.descripcion !== '' && this.planProtectionForm.value.fechaContratado !== '' && this.planProtectionForm.value.fechaVigencia !== '' ){
            this.nextStep()
        }else{
          this.errorsModel.sucursal = this.planProtectionForm.value.sucursal !== '' ? false : true
          this.errorsModel.ordenVenta = this.planProtectionForm.value.ordenVenta !== '' ? false : true
          this.errorsModel.sku = this.planProtectionForm.value.sku !== '' ? false : true
          this.errorsModel.descripcion = this.planProtectionForm.value.descripcion !== '' ? false : true
          this.errorsModel.fechaContratado = this.planProtectionForm.value.fechaContratado !== '' ? false : true
          this.errorsModel.fechaVigencia = this.planProtectionForm.value.fechaVigencia !== '' ? false : true
          this.showError('Es necesario llenar todos los campos para continuar.')
        }
      }else if(this.step === 2){
        if(this.planProtectionForm.value.celular !== '' && this.planProtectionForm.value.nombreCliente !== '' && this.planProtectionForm.value.apellidosCliente !== '' && 
          this.planProtectionForm.value.descripcion !== '' && this.planProtectionForm.value.correoCliente !== '' ){
            if(this.validEmail){
              this.nextStep()
            }else{
              this.showError('Formato de Correo Inválido.')
            }
        }else{
          this.errorsModel.celularCliente = this.planProtectionForm.value.celular !== '' ? false : true
          this.errorsModel.nombreCliente = this.planProtectionForm.value.nombreCliente !== '' ? false : true
          this.errorsModel.apellidosCliente = this.planProtectionForm.value.apellidosCliente !== '' ? false : true
          this.errorsModel.nombreCliente = this.planProtectionForm.value.nombreCliente !== '' ? false : true
          this.errorsModel.correoCliente = this.planProtectionForm.value.correoCliente !== '' ? false : true
          this.showError('Es necesario llenar todos los campos para continuar.')
        }
      }else if(this.step === 3){
        if(this.auto.marca !== '' && this.auto.modelo !== '' && this.auto.year !== '' && this.planProtectionForm.value.noSerie !== '' &&
          this.planProtectionForm.value.kilometraje !== '' && this.planProtectionForm.value.placas !== '' && this.base64NoSerie !== undefined
          && this.base64Placas !== undefined && this.base64tacometro !== undefined){
            this.nextStep()
            const miDiv = document.getElementById('wizardContainer');
            miDiv.scrollTo({
              left: miDiv.scrollLeft + 120,
              behavior: 'smooth'
            });
        }else{
          this.errorsModel.marca = this.auto.marca !== 'Selecciona una marca' ? false : true
          this.errorsModel.modelo = this.auto.modelo !== '' ? false : true
          this.errorsModel.ano = this.auto.year !== '' ? false : true
          this.errorsModel.kilometraje = this.planProtectionForm.value.kilometraje !== '' ? false : true
          this.errorsModel.placas = this.planProtectionForm.value.placas !== '' ? false : true
          this.errorsModel.noSerie = this.planProtectionForm.value.noSerie !== '' ? false : true
          this.errorsModel.img_kilometraje = this.base64tacometro !== undefined ? false : true
          this.errorsModel.img_placas = this.base64Placas !== undefined ? false : true
          this.errorsModel.img_noSerie = this.base64NoSerie !== undefined ? false : true
          this.showError('Es necesario llenar todos los campos para continuar.')
        }
      }else if(this.step === 4){
        if(this.base64ine !== undefined){
            this.nextStep()
        }else{
          
        }
      }else if(this.step === 5){
        if(this.base64tacometro !== undefined ){
            this.nextStep()
        }else{
          
        }
      }
      
    }
  }

  showError(message){
    this.dialog.open(ErrorDialogComponent, {
      width: '424px',
      panelClass: 'custom-dialog',
      data: {
        isError: true,
        error: '',
        message
      }
    });
  }

  nextStep(){
    this.step ++
  }

  backStep(){
    if(this.step === 4){
      const miDiv = document.getElementById('wizardContainer');
      miDiv.scrollTo({
        left: miDiv.scrollLeft - 120,
        behavior: 'smooth'
      });
    }
    this.step --
  }

  closeDialog(){
    // this.dialogRef.close({event: 2})
    this.router.navigate(['pp/en-tramite'])
  }

  closeSaveDialog(){
    // this.dialogRef.close({event: 1})
    this.cambiarSinGuardar = true
    this.router.navigate(['pp/en-tramite'])
  }

  onFileSelected(event: any, opc): void {
    const file: File = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      this.previewPDF(file, opc, event);
    } else {
      alert('Por favor selecciona un archivo PDF');
    }
  }

  previewPDF(file: File, opc, $event): void {
   
  }

  base64ToBlob(base64, mimeType) {
    const byteCharacters = atob(base64.split(',')[1]);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }

    const byteArray = new Uint8Array(byteArrays);
    return new Blob([byteArray], { type: mimeType });
  }

  confirmarGuardar(){
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '424px',
      panelClass: 'custom-dialog',
      data: {
        title: 'Deseas guardar los datos para el Plan Protection ' + this.planProtection.folio + '?',
        description: 'Una vez guardado, no se podrá editar la información'
      }
    })
    dialogRef.afterClosed().subscribe(async result =>  {   
      if (result.exito) {
        this.guardarPlanPro()
      }

    });
  }

  async guardarPlanPro(){

    let img_ine = await this.base64ToBlob(this.base64ine, 'image/png')
    let img_placas = await this.base64ToBlob(this.base64Placas, 'image/png')
    
    if(this.base64Firma === undefined){
      this.base64Firma = 'data:image/png;base64,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'
    }

    let img_firma = await this.base64ToBlob(this.base64Firma, 'image/png')
    let img_tacometro = await this.base64ToBlob(this.base64tacometro, 'image/png')
    let img_noSerie = await this.base64ToBlob(this.base64NoSerie, 'image/png')

    

    this.spinnerService.setMensaje('Guardando cambios...')
    this.spinnerService.show()
    let body = {
      marcaAutoId: this.auto.marca,
      modeloAutoId: this.auto.modelo,
      anioAutoId: this.auto.year,
      kilometraje: this.planProtectionForm.value.kilometraje.replace(',', ''),
      placas: this.planProtectionForm.value.placas,
      noSerie: this.planProtectionForm.value.noSerie,
      email: this.planProtectionForm.value.correoCliente,
      folio: this.planProtection.folio,
      documentoRuta: "",
      empresaId: this.planProtectionDetail.empresaId,
      sucursalId: this.planProtectionDetail.sucursalId,
      usuarioId: localStorage.getItem('id')
    }

    let formData = new FormData()

    for (const key in body) {
      formData.append(key, body[key]);
    }

    formData.append('img_placas', img_placas, 'img_placas.png');
    formData.append('img_noSerie', img_noSerie, 'img_noSerie.png');
    formData.append('img_ine', img_ine, 'img_ine.png');
    formData.append('img_tacometro', img_tacometro, 'img_tacometro.png');
    formData.append('img_firma', img_firma, 'img_firma.png');


    this.ppService.confirmarDatosPlanProtection(formData).subscribe(
      data => {
        if(data.code === 200){
          this.dialog.open(SuccessDialogComponent, {
            width: '424px',
            panelClass: 'custom-dialog',
            data: {
              mensaje: data.message
            }
          })
          this.cambiarSinGuardar = true
          this.closeSaveDialog()
        }else{
          this.showError('Hubo un error al guardar, inténtalo de nuevo.')
        }
        
        this.spinnerService.hide()
      }

    )
  }

  onSignature(dataUrl: string): void {
    this.base64Firma = dataUrl
    this.tieneFirma = true
  }

  limpiarFirma(){
    this.tieneFirma = false
    this.base64Firma = undefined
  }

  onImage(event: { image: string; opcion: number }): void {
    if(event.opcion === 1){
      this.base64ine = event.image
    }else{
      this.base64tacometro = event.image
    }
  }

  desactivarContinuar(event: { opcion: number }): void {
    event.opcion === 1 ? this.base64ine = undefined : this.base64tacometro = undefined
  }

  abrirPdf(){
    
    let base64: any
    let planProPreview = this.planProtectionDetail

    planProPreview['modeloAutoId'] = this.auto.modelo
    planProPreview['marcaAutoId'] = this.auto.marca
    planProPreview['anioAutoId'] = this.auto.year
    planProPreview['email'] = this.planProtectionForm.value.correoCliente
    planProPreview['placas'] = this.planProtectionForm.value.placas
    planProPreview['noSerie'] = this.planProtectionForm.value.noSerie
    planProPreview['kilometraje'] = this.planProtectionForm.value.kilometraje.replaceAll(',','')

    this.ppService.previewPdf(planProPreview).subscribe(
      data => {
        base64 = data.pdf_base64
        const dialogRef = this.dialog.open(VisualizadorPdfComponentDialog, {
          panelClass: 'custom-dialog',
          disableClose: true,
          width: '100vw',
          height: '90vh',
          maxHeight: '720px',
          data: {
            base64,
            blob: true
          }
        });
      }
    )

    
  }

  setCampoAuto(campo, valor, slug, logo){
    if(campo === 'marca'){
      this.auto.marca = valor
      this.auto.logo = logo
      this.auto.marca_slug = slug
      this.planProtectionForm[campo] = valor
      this.errorsModel.marca = false
      this.getModelo()
      this.auto.year = ''
      this.auto.modelo = '' 
      setTimeout(() => {
        this.yearDisabled = true
      }, 3);
      
    }else if(campo === 'year'){
      const selectedYear = (event.target as HTMLSelectElement).value;
      this.auto.year = selectedYear
      this.errorsModel.ano = false
      // this.getModelo()
    }else{
      const selectedYear = (event.target as HTMLSelectElement).value;
      this.auto.modelo = selectedYear
      this.errorsModel.modelo = false
      this.getYear()
    }
  }

  getYear(){
    this.ppService.getYear(this.auto.marca_slug, this.auto.modelo).subscribe(
      data => {
        this.years = data.data
        this.yearDisabled = false
      }
    )
  }

  getModelo(){
    this.ppService.getModelos(this.auto.marca_slug).subscribe(
      data => {
        this.modelos = data.data
        this.modelDisabled = false
      }
    )
  }

  marcasFiltradas() {
    const texto = this.planProtectionForm.value.filtro.toLowerCase();
    return this.marcas.filter(m => m.name.toLowerCase().includes(texto));
  }

  procesarImagenGaleria(event: Event): void {

    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result as string;
      if(this.opcSeleccionarArchivo === 1){
        this.base64tacometro = base64;
      }else if(this.opcSeleccionarArchivo === 2){
        this.base64Placas = base64
      }else if(this.opcSeleccionarArchivo === 3){
        this.base64NoSerie = base64
      }

      // Si quieres mostrar vista previa o guardar en backend, puedes hacerlo aquí
    };
    reader.readAsDataURL(file);
  }

  seleccionarOpcionEvidencia(opc){
    if(this.subirArchivosCarrete){
      const dialogRef = this.dialog.open(SeleccionarCargaModalComponent, {
        panelClass: 'custom-dialog',
        disableClose: true,
        width: '100vw',
        maxWidth: '280',
        height: 'auto',
        maxHeight: '720px',
        data: {
          // title: title
        }
      });
      dialogRef.afterClosed().subscribe(async result =>  {   
        if (!!result) {
          if(result.opcion === 1){
            this.tomarCaptura(opc)
          }else if(result.opcion === 2){
            this.seleccionarArchivo(opc)
          }
        }

      });
    }else{
      this.tomarCaptura(opc)
    }
    
  }

  seleccionarArchivo(opc){
    this.opcSeleccionarArchivo = opc
    if(opc === 1){
      this.fileInput.nativeElement.click();
    }else if(opc === 2){
      this.fileInput2.nativeElement.click();
    }else{
      this.fileInput3.nativeElement.click();
    }
  }

  tomarCaptura(opc){
    let title = ''
    if(opc === 1){
      title = 'Capturar Tacometro'
    }else if(opc === 2){
      title = 'Capturar Placas'
    }else{
      title = 'Capturar Número Serie'
    }

    const dialogRef = this.dialog.open(WebcamDialogComponent, {
      panelClass: 'custom-dialog',
      disableClose: true,
      width: '100vw',
      height: 'auto',
      maxHeight: '720px',
      data: {
        title: title
      }
    });
    dialogRef.afterClosed().subscribe(async result =>  {   
      if (result.event !== 1) {
        return
      }else{
        if(opc === 1){
          this.base64tacometro = result.imagen
        }else if(opc === 2){
          this.base64Placas = result.imagen
        }else if(opc === 3){
          this.base64NoSerie = result.imagen
        }
      }

    });
  }

  validarEmail($event){
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(emailRegex.test($event)){
      this.validEmail = true
      this.errorValidarCorreo = false
    }else{
      this.validEmail = false
      this.errorValidarCorreo = true
    }
    
  }

  soloNumeros(event: KeyboardEvent): void {
    const teclasPermitidas = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    const esNumero = /^[0-9]$/.test(event.key);

    if (!esNumero && !teclasPermitidas.includes(event.key)) {
      event.preventDefault();
    }
  }

  limpiarCaracteresNoNumericos(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Elimina cualquier carácter que no sea número
    input.value = input.value.replace(/[^0-9]/g, '');
  }

  changeMarca($event){
    const input = $event.target as HTMLInputElement;
    this.auto.marca = input.value;
  }

  changeModelo($event){
    const input = $event.target as HTMLInputElement;
    this.auto.modelo = input.value
  }

  changeYear($event){
    const input = $event.target as HTMLInputElement;
    this.auto.year = input.value
  }

  getDisabled(opc){
    if(opc === 1){
      return this.auto.marca !== '' && this.auto.marca !== undefined ? false : true
    }else if(opc === 2){
      return this.auto.modelo !== '' && this.auto.modelo !== undefined ? false : true
    }else{
      return true
    }
  }
}
